"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertInvalidLayer = convertInvalidLayer;
const common_1 = require("./common");
function convertInvalidLayer(nodes) {
    return (problem) => {
        const designatorUidMap = {};
        const designator = problem.affectedItems
            .map((a) => {
            const designator = (0, common_1.sanitizeDesignator)(a.itemLabel ?? (0, common_1.getLabelForPcbNode)(nodes[a.uid]));
            designatorUidMap[designator] = a.uid;
            return designator;
        })
            .join(", ");
        return { name: designator, designator, designatorUidMap };
    };
}
//# sourceMappingURL=invalidLayer.js.map